export const REFUND_TEXT =
  '* Refund is a 7-10 days process. If you don’t get refund then please contact your bank.';
